<template>

    <div class="r-column fr bgw mht-400">
        <div class="r-column-title pb20 ofhidden">
            <Crumb :typeId="typeId"></Crumb>
            <div v-if="!pointList" class="tcenter tc9 fs18 no-cont">
                <div class="iconfont icon-kongneirong"></div>
                抱歉，没有相关内容
            </div>
            <div v-else class="teach-point">
                <div v-for="(item, key) in pointList" :key="key" class="point">
                    <div class="city fs24 pt40">
                        <span class="fs26 iconfont icon-ditu-dibiao"></span>
                        {{item.city}}
                    </div>
                    <div v-for="item2 in item.cities" :key="item2.id" class="borderb-gray pl30 pr20 pt20 pb20 ml10 mr10">
                        <div class="fs20 fbold mb5">{{item2.name}}</div>
                        <div class="tc6 fs16 mb5" v-if="item2.site_unit">设点单位名称：{{item2.site_unit}}</div>
                        <div class="tc6 fs16 mb20">
                            <span class="mr20">电话：{{item2.phone}}</span>
                            <span>地址：{{item2.address}}</span>
                        </div>
                        <div class="mcolor lh18">{{item2.discipline}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Crumb from '@/components/common/Crumb'
export default {
    components: {
        Crumb
    },
    data() {
        return {
            pointList: [],
        }
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function (nV, oV) {
                this.getPoints()
            }
        }
    },
    created() {
        this.getPoints()
    },
    methods: {
        getPoints() {
            this.typeId = this.$route.params.id
            this.$request.get('teaching-point', {}, res => {
                if (res.data.code == 200) {
                    this.pointList = res.data.data
                }
            }, err => {
                console.log(err)
            })
        }
    },
}
</script> 
